// export const firebaseConfig = {
//     apiKey: "AIzaSyDtbsJ2_b7tt5mNvnSdWabEfqIrOyJM1qw",
//     authDomain: "decebe-users.firebaseapp.com",
//     projectId: "decebe-users",
//     storageBucket: "decebe-users.appspot.com",
//     messagingSenderId: "6946021326",
//     appId: "1:6946021326:web:f01e5eed4d3fa28913559f",
//     measurementId: "G-NPKX334T7X"
//   };
  
export const firebaseConfig = {
  appId: 'test-user'
}